import { displayPlainText } from '@/utils/stripHtmlForTooltip';

/**
 * One-line preview of a lot's notes for a result card or grid cell.
 *
 * Lot notes are legacy ILR2 HTML — `<strong>Vaccinations: </strong>Sire
 * Verified.<br>`. Both call sites used to strip only the angle brackets, which
 * left the tag names sitting in the text ("strongVaccinations: /strongSire
 * Verified.br"), so this runs the same tag stripping the rest of the search UI
 * uses. The lot detail panel still renders the markup itself.
 */
export function formatLotNotesPreview(
  lotNotes: string | null | undefined,
  maxLength: number,
): string {
  const plain = displayPlainText(String(lotNotes ?? '').trim());
  if (!plain) return '';
  if (plain.length <= maxLength) return plain;
  return `${plain.slice(0, maxLength - 3)}…`;
}
